import request from "../request";

export const getTargetList = (param) => {
  const url = `/target/${param}`;
  return request.get(url);
};

export const getTargetListWithFilter = (payload) => {
  const url = `/target/filter`;
  return request.post(url, payload);
};

export const getTargetWithId = ({ id }) => {
  const url = `/target/${id}`;
  return request.get(url);
};

export const addTarget = (payload) => {
  const url = "/target/add";
  return request.post(url, payload);
};

export const deleteTarget = ({ id }) => {
  const url = `/target/${id}`;
  return request.delete(url);
};

export const addBatchTarget = (payload) => {
  const url = "/target/save_list";
  return request.post(url, payload);
};
